import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Mountain, Route, ShieldCheck } from "lucide-react";

const PREVIEW = [
  { icon: Mountain, title: "Everest Elevation Virtual Ascent", spec: "8,848 M Gain · 30 Days" },
  { icon: Route, title: "Trans-Himalayan 100K Ultra Circuit", spec: "100 KM · 14 Days" },
];

export default function ChallengesTeaser() {
  return (
    <section className="px-6 sm:px-12 lg:px-20 py-24 sm:py-32 border-t border-[#0D1117]/10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF4E00] mb-5">The Virtual Arena</p>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-[#0D1117] tracking-tight leading-tight">
            Compete from anywhere.
            <span className="italic text-[#FF4E00]"> Verified by Strava.</span>
          </h2>
          <p className="mt-6 text-sm sm:text-base text-[#374151] leading-relaxed max-w-md">
            Every kilometre and every metre of climbing is pulled straight from your Strava device —
            GPS-checked, pace-audited, cheat-proof. The leaderboard only counts what the mountain would.
          </p>
          <Link
            to="/challenges"
            data-testid="teaser-enter-arena"
            className="group mt-9 inline-flex items-center gap-3 bg-[#FF4E00] text-[#FBF9F5] font-mono text-xs uppercase tracking-[0.2em] px-8 py-4 rounded-full transition-all duration-300 hover:bg-[#E04000] hover:gap-5"
          >
            Enter the Arena
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:rotate-45" />
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.15, ease: "easeOut" }}
          className="space-y-5"
        >
          {PREVIEW.map((p) => (
            <div
              key={p.title}
              className="flex items-center justify-between gap-6 rounded-2xl border border-[#0D1117]/10 hover:border-[#FF4E00]/40 bg-[#FFFFFF] px-6 sm:px-8 py-6 transition-colors duration-500"
            >
              <div className="flex items-center gap-5">
                <span className="w-12 h-12 rounded-full border border-[#FF4E00]/30 flex items-center justify-center text-[#FF4E00] shrink-0">
                  <p.icon className="w-5 h-5" />
                </span>
                <div>
                  <h3 className="font-serif text-lg sm:text-xl text-[#0D1117]">{p.title}</h3>
                  <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#6B7280] mt-1.5">{p.spec}</p>
                </div>
              </div>
              <ShieldCheck className="w-5 h-5 text-[#FF4E00] shrink-0" />
            </div>
          ))}
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#6B7280] pl-1">
            Live leaderboard &middot; Anti-cheat verification &middot; Open entry
          </p>
        </motion.div>
      </div>
    </section>
  );
}
